import { useWindowWidth } from "@react-hook/window-size/throttled";

import { thresholds } from "hooks/useNextScreenSizeThreshold";

export function useScreenSizeIsMin(size: keyof typeof thresholds) {
	const width = useWindowWidth();
	return width >= thresholds[size];
}
